export default "__VITE_ASSET__Cc7gwRrq__"